import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 1a1 1 0 1 1 2 0v8.3l2.7-2.5c.4-.5 1.1-.5 1.5 0 .5.4.5 1 0 1.5L5.5 13 .3 8.3a1 1 0 0 1 0-1.5c.5-.5 1.2-.5 1.6 0l2.6 2.5V1ZM0 15c0-.6.5-1 1.1-1h8.8c.6 0 1.1.4 1.1 1s-.5 1-1.1 1H1.1C.5 16 0 15.6 0 15Z",
  fill: "#2B3951"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };